import { QueryCache, QueryClient } from '@tanstack/react-query';
import { TRPCClientError } from '@trpc/client';
import { getQueryKey } from '@trpc/react-query';

import { TRPCRouter } from '~/api/routes';

import { logout } from './auth';

type TRPCErrorCode = NonNullable<TRPCClientError<TRPCRouter>['data']>['code'];

export type TRPCQuery = Parameters<typeof getQueryKey>[0];

const maxRetries = 2;

const trpcErrorCodesToNotRetry: TRPCErrorCode[] = [
  'BAD_REQUEST',
  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
];

const isTrpcClientError = (error: unknown): error is TRPCClientError<TRPCRouter> =>
  error instanceof TRPCClientError;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (failureCount > maxRetries) {
          return false;
        }
        if (
          isTrpcClientError(error) &&
          error.data &&
          trpcErrorCodesToNotRetry.includes(error.data.code)
        ) {
          return false;
        }
        return true;
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      const isUnauthorised = isTrpcClientError(error) && error.data?.code === 'UNAUTHORIZED';

      if (isUnauthorised) {
        void logout();
      }
    },
  }),
});
